import {
  Directive,
  ElementRef,
  AfterViewInit,
  Renderer2,
  Input,
} from '@angular/core';
import { Router } from '@angular/router';
import { Reference } from '../models';
import { transformVimeoEmbedsInElement } from '../utils/vimeo-embed.util';

@Directive({
  selector: '[primeCmsBody], [primeReference]',
  standalone: true,
})
export class CmsBodyDirective implements AfterViewInit {
  @Input() references: Reference[] = [];
  private activeToolTip: HTMLElement | null = null;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private router: Router
  ) {}

  ngAfterViewInit() {
    const element = this.el.nativeElement;
    this.transformReferences(element);
    this.transformVimeoEmbeds(element);
  }

  private transformReferences(element: HTMLElement) {
    if (!this.references?.length) {
      return;
    }

    const supElements = element.querySelectorAll('sup');
    supElements.forEach((supElement: HTMLElement) => {
      const referenceId = supElement.getAttribute('data-reference');
      const reference = this.references.find((r) => r.id === referenceId);

      if (reference) {
        const newSup = this.renderer.createElement('sup');
        const button = this.renderer.createElement('button');
        this.renderer.addClass(newSup, 'button-sup');
        this.renderer.addClass(button, 'button-ref');

        this.renderer.appendChild(
          button,
          this.renderer.createText(reference.uniqueID.toString())
        );
        this.renderer.appendChild(newSup, button);

        const citationTooltip = this.renderer.createElement('div');
        this.renderer.addClass(citationTooltip, 'ref-citation-tooltip');
        this.renderer.addClass(citationTooltip, 'hidden');

        const citationWrapper = this.renderer.createElement('div');
        this.renderer.addClass(citationWrapper, 'ref-citation-tooltip-wrapper');

        const iconContainer = this.renderer.createElement('div');
        this.renderer.addClass(iconContainer, 'icon-container');

        const icon = this.renderer.createElement('ion-icon');
        this.renderer.setAttribute(icon, 'name', 'information-circle-outline');

        const citation = this.renderer.createElement('p');
        this.renderer.addClass(citation, 'ref-inline-short-citation');
        this.renderer.setProperty(citation, 'innerHTML', reference.citation);
        const body = document.getElementById('body');

        this.renderer.appendChild(iconContainer, icon);
        this.renderer.appendChild(citationWrapper, iconContainer);
        this.renderer.appendChild(citationWrapper, citation);
        this.renderer.appendChild(citationTooltip, citationWrapper);

        this.renderer.listen(button, 'click', (event) => {
          event.stopPropagation();

          if (this.activeToolTip === citationTooltip) {
            this.renderer.addClass(citationTooltip, 'hidden');
            this.activeToolTip = null;
          } else {
            if (this.activeToolTip) {
              this.renderer.addClass(this.activeToolTip, 'hidden');
            }
            this.renderer.removeClass(citationTooltip, 'hidden');
            this.activeToolTip = citationTooltip;
          }

          this.router.navigate([
            '',
            { outlets: { modal: ['viewer', 'reference', referenceId] } },
          ]);
        });

        this.renderer.listen(button, 'mouseenter', () => {
          this.renderer.removeClass(citationTooltip, 'hidden');
          this.activeToolTip = citationTooltip;
        });
        this.renderer.listen(button, 'mouseleave', () => {
          this.renderer.addClass(citationTooltip, 'hidden');
          this.activeToolTip = null;
        });

        body?.appendChild(citationTooltip);
        supElement.parentElement?.replaceChild(newSup, supElement);
      }
    });
  }

  private transformVimeoEmbeds(element: HTMLElement) {
    transformVimeoEmbedsInElement(element);
  }
}
